export default __webpack_public_path__ + "static/media/tabler-icon-ban.92815070.svg";